/* eslint-disable react/prop-types */
import React, {useState} from "react";

import {HiMinusSm, HiPlusSm} from "react-icons/hi";
import {ModalApp} from "components/Modal";
import Button from "components/Button";
import {classes} from 'utils'
import {useApp} from "contexts/AppContext";
import {changeClassAirfareAction, changePassengersAirfareAction} from "contexts/reducers/airfare/actions";
import {AiOutlineUser} from "react-icons/ai";

export default function Passengers() {

    const { airfareState, airfareDispatch } = useApp()
    const { numberOfPassengers } = airfareState

    const [open, setOpen] = useState(false)

    const [passengers, setPassengers] = useState(numberOfPassengers)

    const handleModal = () => {
        airfareDispatch(changePassengersAirfareAction(passengers))
        airfareDispatch(changeClassAirfareAction(airfareState))
        setOpen(!open);
    };

    let adults = Number(numberOfPassengers.adults) > 1 ? numberOfPassengers.adults + ' adultos' : numberOfPassengers.adults + ' adulto'

    let babys = Number(numberOfPassengers.baby) > 1
        ? ', '+ numberOfPassengers.baby + ' bebês'
        : Number(numberOfPassengers.baby) === 1 ? ', '+ numberOfPassengers.baby + ' bebê' : ''

    let children = Number(numberOfPassengers.children) > 1
        ? ', '+ numberOfPassengers.children + ' crianças'
        : Number(numberOfPassengers.children) === 1 ? ', '+ numberOfPassengers.children + ' criança' : ''

    const handlePeople = (type, action) => {
        let newPassenger = {...passengers}

        if (action === 'add') {

            if( type === 'baby' && newPassenger['adults'] <= newPassenger['baby']) {
                return
            }

            const sumPassengers = newPassenger['adults'] + newPassenger['children'] + newPassenger['baby'] ;
            if(sumPassengers === 9) {
                return
            }

            //aumenta qtde adultos e criancas
            newPassenger[type] = newPassenger[type] + 1;
            setPassengers(newPassenger)
            return
        }

        if (type === 'adults' && newPassenger['adults'] === 1) return

        //diminui qtde adultos e criancas
        if (newPassenger[type] === 0) return

        if ( type === 'adults' && newPassenger['baby'] === newPassenger['adults']) {
            return
        }

        newPassenger[type] = newPassenger[type] - 1;
        setPassengers(newPassenger)
    }

    const InputControl = ({type, placeholder, value}) => {
        return (
            <div className="input-group">
                <label className="label-custom">{placeholder}</label>
                <span className="input-group-custom">
                    <span className="px-1" role="button"
                          onClick={() => handlePeople(type, 'remove')}>
                        <HiMinusSm/>
                    </span>
                </span>
                <span className="input-group-custom px-0">{value}</span>
                <span className="input-group-custom">
                   <span className="px-1" onClick={() => handlePeople(type, 'add')}>
                        <HiPlusSm/>
                    </span>
                </span>
            </div>
        )
    }

    return (
        <div className="content-custom">
            <div className="input-group flex-nowrap" onClick={handleModal}>

                <input
                    className="form-control form-control-custom border-custom"
                    value={ adults + '' + children + '' + babys }
                    onChange={handleModal}
                    onClick={() => handleModal}
                    placeholder="Nº de passageiros"
                    readOnly
                />

            </div>

            <ModalApp show={open} handleModal={handleModal}>
                <div className="p-4 bg-content">
                    <div className="row">
                        <div className="col d-grid gap-4">
                            <span className="label-modal">
                                Passageiros
                            </span>

                            <div className="text-start">
                                <InputControl placeholder="Adultos" type="adults" value={passengers.adults}/>
                                <span className="text-xs">A partir de 12 anos</span>
                            </div>

                            <div className="text-start">
                                <InputControl placeholder="Crianças" type="children" value={passengers.children} />
                                <span className="text-xs">2 a 11 anos</span>
                            </div>

                            <div className="text-start">
                                <InputControl placeholder="Bebê" type="baby" value={passengers.baby} />
                                <span className="text-xs">0 a 23 meses</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="my-4 d-flex justify-content-center">
                    <Button type="button" width="200px" onClick={handleModal}>CONTINUAR</Button>
                </div>
            </ModalApp>
        </div>
    );
}
